/*
 * @Description:抖音待编渠道路由
 * @Author: cc
 * @LastEditors: cc
 * @Date: 2019-10-26
 * @LastEditTime: 2021-01-05 16:07:23
 */
'use strict';
angular.module('editKuaishouToBeCompiledRouterModule', []).config([
    '$stateProvider',
    function ($stateProvider) {
        $stateProvider
            .state('front.editctr.kuaishou.waitcompiled', {
                url: '/waitcompiled?account?channelid', // accountid->账号
                views: {
                    'main@front.editctr': {
                        templateUrl:
                            './editingCenter/kuaishou/toBeCompiled/main.html',
                        controller: 'EditKuaishouToBeCompiledCtrl'
                    }
                }
            }).state('front.editctr.kuaishou.pending', {
                url: '/pending?account&channelid', // accountid->账号
                views: {
                    'main@front.editctr': {
                        templateUrl: './editingCenter/kuaishou/pending/main.html',
                        controller: 'EditKuaishouPendingCtrl',
                    },
                },
            }).state('front.editctr.kuaishou.signed', {
                url: '/signed?account&channelid', // accountid->账号
                views: {
                    'main@front.editctr': {
                        templateUrl: './editingCenter/kuaishou/signed/main.html',
                        controller: 'EditKuaishouSignedCtrl',
                    },
                },
            }).state('front.editctr.kuaishou.draftbox', {
                url: '/draftbox?account&channelid', // account->账号
                views: {
                    'main@front.editctr': {
                        templateUrl: './editingCenter/kuaishou/draftBox/main.html',
                        controller: 'EditKuaishouDraftBoxCtrl'
                    }
                }
            })
            .state('kuaishoudraft', {
                url: '/kuaishoudraft?accountid&articleid&platform',
                views: {
                    '': {
                        templateUrl: './editingCenter/kuaishou/draft/main.html',
                        controller: 'EditKuaishouDraftCtrl'
                    }
                }
            });
    }
]);
